module.exports = __webpack_public_path__ + "static/ali-about-photo-6cdd4b46b6ae809f9a75b8d481eb7158.png";